import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DueSurveyDialogData } from '../dialogs-data/due-survey-dialog-data';
import { DueSurveyDialogComponent } from '../dialogs/due-survey-dialog/due-survey-dialog.component';

@Injectable()
export class DueSurveyDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<DueSurveyDialogComponent>;

    open(dueSurveyDialogData: DueSurveyDialogData) {
        if (!dueSurveyDialogData) {
            console.error('DueSurveyDialogService: Dialog data is required');
            return;
        }
        
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.data = dueSurveyDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        
        this.matDialogRef = this.dialog.open(DueSurveyDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
